import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../app";

// Define a settingModal for the slice state
interface settingModalState {
  open: boolean;
}

// Define the initial state using that settingModal
const initialState: settingModalState = {
  open: false,
};

export const settingModalSlice = createSlice({
  name: "settingModal",
  // `createSlice` will infer the state settingModal from the `initialState` argument
  initialState,
  reducers: {
    addsettingModal: (state, action) => {
      state.open = action.payload;
    },
  },
});

export const { addsettingModal } = settingModalSlice.actions;

// Other code such as selectors can use the imported `RootState` settingModal
export const getsettingModalDetails = (state: RootState) =>
  state.settingModal.open;

export default settingModalSlice.reducer;
